import styled from "styled-components";
import { windowWidth } from "@styles/global";
import { shade } from "polished";

const ParamsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: ${windowWidth.tablet}) {
    width: 100%;
  }
`;

const ParamItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 2rem;
  }
  
  .MuiTextField-root.numberInput {
    width: 3rem;
    
    input {
      text-align: center;
    }
  }
`;

const ParamItemText = styled.div`
  font-size: 0.875rem;
  color: rgba(0,0,0, 0.6);
  width: 50%;

  @media (max-width: ${windowWidth.tablet}) {
    width: 75%;
  }
`;

const SubmitButton = styled.button`
  display: flex;
  padding: 12px 8px;
  margin-left: auto;
  cursor: pointer;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.primary};
  background-color: #fff;
  border: 3px solid ${({ theme }) => theme.colors.primary};
  font-weight: 600;

  &:hover:enabled {
    background-color: ${() => shade(0.2, "#e0e0eb")};
  }

  @media (max-width: ${windowWidth.tablet}) {
    transform: scale(1);
  }
`;

export default {
  ParamsContainer,
  ParamItem,
  ParamItemText,
  SubmitButton
};